import $ from 'jquery'
import { isMobileBreakpoint } from './helpers'

const video = document.getElementById('hero-video')

function isMobile() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ]

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem)
  })
}

/*
  Preload images if not on a mobile device
*/

let imagesReady = true // Assume images are ready if we're on a mobile device

if ((!isMobileBreakpoint(), !isMobile())) {
  let imagesLoadedCount = 0
  imagesReady = false // Now we're not sure if images are ready
  const images = document.querySelectorAll('img[data-src]')

  images.forEach((image) => {
    const newImg = new Image()
    newImg.onload = function () {
      imagesLoadedCount++
      image.src = newImg.src // set image src once loaded
      if (imagesLoadedCount === images.length) {
        // All images are loaded
        imagesReady = true
      }
    }
    newImg.src = image.dataset.src
  })
}

/*
  Wait for both
*/

// const waiter = setInterval(() => {
//   if (imagesReady) {
//     $('body').addClass('loaded')
//     video.play()

//     setTimeout(function () {
//       $('body').addClass('fully-loaded')

//       if (
//         window.location.href.indexOf('submitted') > -1 ||
//         window.location.href.indexOf('error') > -1
//       ) {
//         document.getElementById('contact').scrollIntoView()
//       }
//     }, 1010)

//     clearInterval(waiter)
//   }
// }, 10)
